<template>
  <div class="invoiceissue-data">
    <div class="invoiceissue-data-top">
      <span>发票记录</span>
    </div>
    <div class="invoiceissue-data-bottom">
      <div class="invoiceissue-data-search">
        
        
          <el-input v-model="phone_number" clearable placeholder="请输入手机号"></el-input>
         
                <el-date-picker
                  v-model="start_date"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择开票时间"
                  style="width: 210px;"
                ></el-date-picker>
  
                <el-date-picker
                  v-model="end_date"
                  type="datetime"
                  placeholder="请选择结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                   :picker-options="pickerOptions"
                  style="width: 210px;"
                ></el-date-picker>
                  
        <el-button class="btn-search" @click="searchClick()">查询</el-button>        
        <div style="clear:both;"></div>
      </div>
      <div class="invoiceissue-data-table">
        <el-table
          :data="yemiandata"
          :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
          border
          style="width: 100%">
          <el-table-column
            prop="orderNo"
            label="发票申请号"
            width="160">
            <template slot-scope="scope">{{ scope.row.orderNo | defaultValFilter }}</template>
          </el-table-column>         
          <el-table-column
            prop="openid"
            label="openid"
            width="240">
            <template slot-scope="scope">{{ scope.row.openid | defaultValFilter }}</template>
          </el-table-column>
           <el-table-column
            prop="phone"
            label="手机号"
            width="120">
            <template slot-scope="scope">{{ scope.row.phone | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="email"
            label="邮箱"
            width="120">
            <template slot-scope="scope">{{ scope.row.email | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="money"
            label="金额(元)"
            width="120">
            <template slot-scope="scope">{{ scope.row.money | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="invoiceType"
            label="发票类型"
            width="150">
            <!-- <template slot-scope="scope">{{ scope.row.invoiceType | defaultValFilter }}</template> -->
            <template slot-scope="scope">
              <span v-if="scope.row.invoiceType == 1">蓝票</span>
              <span v-else-if="scope.row.invoiceType == 2">红票</span>
              <span v-else>未知</span>
            </template>
          </el-table-column>
           <el-table-column
            prop="invoiceId"
            label="发票流水号"
            width="150">
            <template slot-scope="scope">{{ scope.row.invoiceId | defaultValFilter }}</template>
          </el-table-column>
           <el-table-column
            prop="blueInvoiceNumber"
            label="蓝字发票号码"
            width="160">
            <template slot-scope="scope">{{ scope.row.blueInvoiceNumber | defaultValFilter }}</template>
          </el-table-column>
           <el-table-column
            prop="buyerName"
            label="购买方名称"
            width="100">
            <template slot-scope="scope">{{ scope.row.buyerName | defaultValFilter }}</template>
          </el-table-column>         
          <el-table-column
            prop="buyerTaxnum"
            label="购买方税号"
            width="110">
            <template slot-scope="scope">{{ scope.row.buyerTaxNum | defaultValFilter }}</template>
          </el-table-column>    
         
          <el-table-column
            prop="insertTime"
            label="蓝票申请时间"
            width="140">
            <template slot-scope="scope">{{ scope.row.insertTime | defaultValFilter }}</template>
          </el-table-column> 

          <el-table-column
            prop="blueInvoiceStatus"
            label="蓝票状态"
            width="50">
            <template slot-scope="scope">
              <span 
                v-if="scope.row.blueInvoiceStatus == 1" 
                style="color: #4CAF50;">开具成功</span> 
              <span 
                v-else-if="scope.row.blueInvoiceStatus == 2" 
                style="color: #2196F3;">开票中</span> 
              <span 
                v-else-if="scope.row.blueInvoiceStatus == 3" 
                style="color: red;">开票失败</span> 
              <span 
                v-else-if="scope.row.blueInvoiceStatus == 4" 
                style="color: #FF9800;">重开成功</span> 
              <span 
                v-else-if="scope.row.blueInvoiceStatus == 5" 
                style="color: #9E9E9E;">被红冲</span> 
              <span 
                v-else-if="scope.row.blueInvoiceStatus == 6" 
                style="color: #AB47BC;">红冲后重开</span> 
              <span 
                v-else-if="scope.row.blueInvoiceStatus == 9" 
                style="color: #D32F2F;">异常</span> 
              <span v-else>未知</span>
            </template>
          </el-table-column> 
          <el-table-column
            prop="startTime"
            label="蓝票开具时间"
            width="140">
            <template slot-scope="scope">{{ scope.row.startTime | defaultValFilter }}</template>
          </el-table-column> 
          <el-table-column
            prop="redInvoiceStatus"
            label="红票状态"
            width="50">
            <!-- <template slot-scope="scope">{{ scope.row.redInvoiceStatus | defaultValFilter }}</template> -->
            <template slot-scope="scope">
              <span v-if="scope.row.redInvoiceStatus == 0">未冲红</span>
              <span v-else-if="scope.row.redInvoiceStatus == 1">已冲红</span>
              <span v-else-if="scope.row.redInvoiceStatus == 2">冲红中</span>
              <span v-else-if="scope.row.redInvoiceStatus == 3">冲红失败</span>
              <span v-else-if="scope.row.redInvoiceStatus == 4">重新冲红</span>
              <span v-else-if="scope.row.redInvoiceStatus == 9">异常</span>
              <span v-else>未知</span>
            </template>
          </el-table-column>     
          <el-table-column width="270" label="操作">
            <template slot-scope="scope">             
              <el-button
                class="btn resend"
                @click="resendClick(scope.row)"
                :disabled="resendPrivilege == 1"
                :class="[resendPrivilege == 1 ? 'active' : '']"
              >重新发送</el-button>  
              <el-button
                class="btn reissue"
                @click="reissueClick(scope.row)"
                :disabled="reissuePrivilege == 1"
                :class="[reissuePrivilege == 1 ? 'active' : '']"
              >重开发票</el-button>
              <el-button
                class="btn query"
                @click="getQueryClick()"
                :disabled="queryPrivilege == 1"
                :class="[queryPrivilege == 1 ? 'active' : '']"
              >认证查询</el-button>            
            </template>
          </el-table-column>         
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next, jumper, sizes"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <!-- 重发发票 -->
    <el-dialog
		:visible.sync="resendDialog"
    customClass="resend-dialog"		
    @close="resendCancelClick"
    :close-on-click-modal="false"
		>
      <p class="title">重新发送发票</p>
      <div class="line"></div>
      <div class="new-resend-parameter">
        <div class="parameter">
          
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">邮箱：</span>
          <el-input
            v-model="add_email"
            clearable
            placeholder="请输入用户邮箱"
          ></el-input>
        </div>

         <div class="parameter-btn">
           <el-button class="cancel" @click="resendCancelClick()">取消</el-button>
           <el-button class="confirm" @click="resendConfirmClick()">确认</el-button>
      </div>
      </div>
      
    </el-dialog>      
  </div>
</template>

<script>
export default {
  data () {
    return {
      resendDialog: false,
      reissueDialog: false,
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 每页展示条数
      pageSize: 10,
      // 当前页码
      currentPage: 1,
      // 数据总条数
      totalNum: 0,
      // 总页数
      totalPages: 0,
      input: "",
      nickname: "",
      openid: "",
      plateNumber: "",
      phone_number: "",
      start_date: "",
      end_date: "",
      add_email: "",
      // 新增存储发票状态
      blueInvoiceStatus: "",
      resendPrivilege: 1, // 重发发票
      reissuePrivilege: 1, // 重开发票
      reissueDisabled: false, // 重复操作限制
      queryPrivilege: 1, // 查询
      // 新增存储发票流水号
      invoiceId: '',
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.start_date).getTime() || time.getTime() > Date.now()
          );
        },
   
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      

      let role = [];
      role = this.$store.state.role;
      
      for(let i in role){
        
        if(role[i].view_name == "会员管理"){
          for(let j in role[i].chlid){           
            if(role[i].chlid[j].view_name == "发票记录"){
              this.resendPrivilege = 0;
              this.reissuePrivilege = 0;
              this.queryPrivilege = 0;
            }
          }
        }
      }

      this.getDataList();
    });
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getDataList();
    },
    getDataList() {
      const params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getInvoices",
        phone_number: this.phone_number,
        email: this.add_email,
        start_date: new Date(this.start_date).getTime(),
        end_date: new Date(this.end_date).getTime(),
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };

      this.$api({
        method: "post",
        url: "/api.php/Invoice/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
      .then(su => {
        if (su.data.code === 1) {
          this.tableData = su.data.list;
          this.yemiandata = this.tableData;
          this.totalNum = su.data.total;
          this.totalPages = su.data.pages;
        } else if (su.data.code === 300) {
          localStorage.clear(); 
          this.$router.push('/login');
          this.$message.warning(su.data.message);
        } else if (su.data.code === 900)  {
          // 处理特定错误
        } else {
          this.$message.warning(su.data.message);
        }
      })
      .catch(err => {
        // 处理错误
        this.$message.error('查询出错，请稍后重试');
      });
    },
    searchClick() {
      this.currentPage = 1;
      this.getDataList();
    }, 
    resendClick(row){
      this.title = "重新发送发票";
      // 存储发票流水号
      this.invoiceId = row.invoiceId;
      // 存储发票状态
      this.blueInvoiceStatus = row.blueInvoiceStatus;
      this.resendDialog = true;
    },  
    resendCancelClick() {
      this.resendDialog = false;
      this.add_email = "";           
      // 清空发票流水号
      this.invoiceId = '';     
    }, 
    resendConfirmClick(){
      if(this.ValidateEmail(this.add_email)){

        this.resendinvoice();
      }
    },
    // ValidatePhone(val) {
    //   var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/; // 座机号码
    //   var isMob = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/; // 手机号码
      
    //   if (isMob.test(val) || isPhone.test(val)) {
    //     return true;
    //   } else {
    //     return false;
    //   }   
    // },
    ValidateEmail(param){
      let strictEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.add_email !== "") {
        if (strictEmailRegex.test(param)) {
          return true;
        } else{
          this.$message.warning("邮箱格式错误！");
          return false;
        }
      } else {
        this.$message.warning("请将信息填写完成");
        return false;
      }
    },
    resendinvoice() {
      if (this.add_email.indexOf(" ") >= 0) {
        this.$message.warning("email不能含空格！");
        return;
      }

      // 显示发送中提示
      const loadingMessage = this.$message({
        message: '正在发送中...',
        type: 'info',
        duration: 0,
        showClose: false
      });

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "resendinvoice",
        invoiceId: this.invoiceId,
        email: this.add_email,
        blueinvoicestatus: this.blueInvoiceStatus
      };

      this.$api({
        method: "post",
        url: "/api.php/Invoice/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // 关闭发送中提示
          loadingMessage.close();
          if (su.data.code == 1) {
            this.resendDialog = false;
            this.getDataList();
            this.$message.success(su.data.message);
            this.add_email = "";
            this.invoiceId = '';
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {
          // 关闭发送中提示
          loadingMessage.close();
          this.$message.error('请求出错，请稍后重试');
        });
    },

    invoiceMold(row){
      if(row.buyerTaxNum != undefined){
        return 1;
      }else if(row.buyerTaxNum == undefined){
        return 2;
      }
    },

    reissueClick(row){
      if(this.reissueDisabled) {
        this.$message.warning('请勿重复开票操作');
        return;
      }
      this.$confirm("确定重新开具", "开具", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        // 显示提交中
        const loadingMessage = this.$message({
          message: '正在提交中...',
          type: 'info',
          duration: 0,
          showClose: false
        });

        let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action: "reissueinvoice",
          // 对应后端 orderNo
          orderNo: row.orderNo,
          // 对应后端 invoiceMold
          invoiceMold: this.invoiceMold(row),
          // 对应后端 blueinvoicestatus
          blueinvoicestatus: row.blueInvoiceStatus,
          
        };

        this.$api({
          method: "post",
          url: "/api.php/Invoice/index",
          data: params,
          transformRequest: [
            (data) => {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
        })
          .then((su) => {
            loadingMessage.close();
            if (su.data.code == 1) {
              this.reissueDisabled = true;
              setTimeout(() => {
                this.reissueDisabled = false;
              }, 15000);
              this.getDataList();
              this.$message.success(su.data.message);
            } else {
              this.$message.warning(su.data.message);
            }
          })
          .catch((err) => {
            loadingMessage.close();

            this.$message.error('请求出错，请稍后重试');
          });
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    }, 
    
    getQueryClick() {
      this.$confirm('确定进行认证查询？', '认证查询', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.getQuery();
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    getQuery() {
      // 显示查询中提示
      const loadingMessage = this.$message({
        message: '正在查询中...',
        type: 'info',
        duration: 0,
        showClose: false
      });

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getQuery"
      };

      this.$api({
        method: "post",
        url: "/api.php/Invoice/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // 关闭查询中提示
          loadingMessage.close();
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {
          // 关闭查询中提示
          loadingMessage.close();
          this.$message.error('查询出错，请稍后重试');
        });
    },
  },
}
</script>

<style scoped lang="scss">
.invoiceissue-data {
  .invoiceissue-data-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    span {
      line-height: 60px;
      font-size: 16px;
      color: #0076bc;
      margin-left: 20px;
      font-weight: 700;
    }
  }
  .invoiceissue-data-bottom {
    width: 98%;
    margin-left: 1%;
    margin-top: 12px;
    background-color: #ffffff;
    padding-top: 20px;
    padding-bottom: 14px;
    .invoiceissue-data-search {
      width: 98%;
      margin-left: 1%;
      .el-input {
        width: 12%;
        float: left;
        margin-right: 10px;
      }
      .btn-search {
        background-color: #0071bd;
        border:none;
        color: #feffff;
        float: left;
      }
      .btn-search:active {
        background-color: #409EFF;
      }
      .btn-blacklist {
        background-color: #f15500;
        border:none;
        color: #feffff;
        float: left;
      }
    }
    .invoiceissue-data-table {
      margin-top: 28px;
      width: 98%;
      margin-left: 1%;
      .btn {
        width: 52px;
        height: 26px;
        background-color: #0071bd;
        border: none;
        color: #fffeff;
        padding: 0 !important;
        font-size: 12px;
      }
      .resend {
        background-color: #02b271;
      }
      .img {
        background-color: #f05502;
      }
      .reissue.active {
        background-color: #a5a5a5;
      }
      .query {
        background-color: #1E88E5;
      }
      .query.active {
        background-color: #a5a5a5;
      }
      .details {
        background-color: rgb(165, 2, 240);
      }
      .resend.active {
        background-color: #a5a5a5;
      }
      .img.active {
        background-color: #a5a5a5;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
  .resend-dialog {
  position: relative;
  overflow-x: hidden;
  .title {
    font-size: 18px;
    position: absolute;
    left: 16px;
    top: 16px;
    color: #0171bd;
  }
  .line {
    width: calc(100% + 40px);
    margin-left: -20px;
    margin-right: -20px;
    height: 1px;
    background-color: #eaeaea;
    margin-bottom: 30px;
  }
  .new-resend-parameter {
  width: 100%;
  .parameter {
    width: 70%;
    height: 40px;
    line-height: 40px;
    text-align: right;
    margin-left: 10%;
      margin-bottom: 16px;
      position: relative;
      .star {
        color: #ea0000;
      }
      .tool-tip {
        margin-left: 10px;
        background-color: #ea0000;
        color: #ffffff;
        font-size: 22px;
        display: inline-block;
        width: 22px;
        height: 22px;
        line-height: 22px;
        border-radius: 50%;
        text-align: center;
        position: absolute;
        right: -30px;
        top: 9px;
      }
      .ml-13 {
        margin-left: 13px;
      }
      .ml-40 {
        margin-left: 40px;
      }
      .el-input,
      .el-select {
        width: 76%;
        float: right;
      }
    }
   
    .parameter-btn {
      margin-top: 40px;
      text-align: center;
      .cancel {
        width: 26%;
        background-color: #0071bd;
        color: #ffffff;
        border: none;
        height: 40px;
      }
      .confirm {
        width: 26%;
        background-color: #02b36f;
        color: #ffffff;
        border: none;
        height: 40px;
      }
    }
  }
  }

}
</style>
<style lang="scss">
.invoiceissue-data .el-table--enable-row-hover .el-table__body tr:hover>td {
  .signed {
    color:#ffffff;
  }
  .terminated {
    color:#ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ invoiceissueManagement/ invoiceissueData.vue